module.exports = __webpack_public_path__ + "img/performance-test-icon2.e45b6515.png";